module.exports = __webpack_public_path__ + "img/question-circle1.a83953cf.svg";